import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import BodyText from 'components/Luxkit/Typography/BodyText'
import LineAngleRightIcon from 'components/Luxkit/Icons/line/LineAngleRightIcon'
import { mediaQueryUp } from 'components/utils/breakpoint'
import StepCheckedCircle from './StepCheckedCircle'

const CheckoutStepsWrapper = styled.div`
  display: none;
  align-items: center;

  ${mediaQueryUp.desktop} {
    display: flex;
  }
`

const StepsContentItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem(16)};
  padding: ${rem(8)};
`

const StepActiveCircle = styled.div`
  width: ${rem(18)};
  height: ${rem(18)};
  border: 3px solid ${({ theme }) => theme.palette.brand.primary.normal};
  border-radius: 100%;
`

const StepPendingCircle = styled.div`
  width: ${rem(18)};
  height: ${rem(18)};
  border: 1px solid ${({ theme }) => theme.palette.neutral.default.six};
  border-radius: 100%;
`

const StepLineAngleRightIcon = styled(LineAngleRightIcon)`
  color: ${({ theme }) => theme.palette.neutral.default.five};
`

interface CheckoutStep {
  label: string;
  step: string;
  isRoute: boolean;
  subSteps?: CheckoutStep[];
}

interface Props {
  currentStepIndex: number;
  steps: CheckoutStep[];
}

function CheckoutSteps({ currentStepIndex, steps }: Props) {
  return <CheckoutStepsWrapper>
    {steps.map((step, index) => {
      const isCompleted = index < currentStepIndex
      const isActive = index === currentStepIndex
      const isPending = index > currentStepIndex
      const isLast = index === steps.length - 1

      return <StepsContentItem key={step.step}>
        {isCompleted && <StepCheckedCircle />}
        {isActive && <StepActiveCircle />}
        {isPending && <StepPendingCircle />}
        <BodyText
          variant="medium"
          weight={isActive ? 'bold' : 'normal'}
          colour={isPending ? 'neutral-four' : undefined}
        >{step.label}</BodyText>

        {!isLast && <StepLineAngleRightIcon />}
      </StepsContentItem>
    })}
  </CheckoutStepsWrapper>
}

export default CheckoutSteps
